import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { Feature } from "@/model/features";

interface FeaturesState {
  byPlan: Record<string, Feature[]>;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: FeaturesState = {
  byPlan: {},
  status: "idle",
  error: null,
};

const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {
    setFeatures: (
      state,
      action: PayloadAction<{ byPlan: Record<string, Feature[]> }>,
    ) => {
      state.byPlan = action.payload.byPlan;
      state.status = "succeeded";
      state.error = null;
    },
    setFeaturesStatus: (
      state,
      action: PayloadAction<FeaturesState["status"]>,
    ) => {
      state.status = action.payload;
    },
    setFeaturesError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.status = "failed";
    },
  },
});

export const { setFeatures, setFeaturesStatus, setFeaturesError } =
  featuresSlice.actions;

export default featuresSlice.reducer;
